import React, { useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import './profile.css';
import { useTranslation } from 'react-i18next';

const ManagementUserSettingWrapper = ({ children }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const stateData = location.state;

  useEffect(() => {
    if (stateData.userType === 'staff') {
      window.location.href = '/staff_login';
    }
  }, [stateData]);

  return (
    <div className="container">
      <div>
        <div className="d-flex">
          { stateData.userType === 'distributor' ?
          (<NavLink
            to="/users/operator"
            className={({ isActive, isPending }) =>
              isPending
                ? 'pending'
                : isActive
                ? 'user-setting-active user-nav-link me-3'
                : 'user-nav-link me-3'
            }
            state={stateData}
          >
            {t('Operator')}
          </NavLink>) : null }

          <NavLink
            to="/users/staff"
            className={({ isActive, isPending }) =>
              isPending
                ? 'pending'
                : isActive
                ? 'user-setting-active user-nav-link me-3'
                : 'user-nav-link me-3'
            }
            state={stateData}
          >
            {t('Staff')}
          </NavLink>

          <NavLink
            to={'/users/roles'}
            className={({ isActive, isPending }) =>
              isPending
                ? 'pending'
                : isActive
                ? 'user-setting-active user-nav-link me-3'
                : 'user-nav-link me-3'
            }
            state={stateData}
          >
            {t('Roles List')}
          </NavLink>

          <NavLink
            to={'/users/notification'}
            className={({ isActive, isPending }) =>
              isPending
                ? 'pending'
                : isActive
                ? 'user-setting-active user-nav-link me-3'
                : 'user-nav-link me-3'
            }
            state={stateData}
          >
            {t('Notification List')}
          </NavLink>
        </div>
        <div className="mt-4">
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, { state: stateData });
            }
            return child;
          })}
        </div>
      </div>
    </div>
  );
};

export default ManagementUserSettingWrapper;
